<p-toast
  styleClass="toast"
  position="bottom-center"
  [life]="SETTINGS['TOAST_LIFE']"
>
  <ng-template
    #message
    let-message
  >
    <div class="toast__content">
      @switch (message.severity) {
        @case ('error') {
          <app-svg-icon
            class="toast__icon"
            name="info-circle"
          />
        }
      }
      <div class="toast__message">
        {{ message.detail }}
      </div>
    </div>
  </ng-template>
</p-toast>
